import * as Sentry from '@sentry/vue'

import { useDjangoAuthStore } from '@/stores/authDjango'

export const useSentryFeedback = () => {
  const authStore = useDjangoAuthStore()
  const feedback = Sentry.getFeedback()
  if (!feedback) return

  let widget: ReturnType<typeof feedback.createWidget> | null = null

  const isAuthenticated = () => {
    return authStore.user !== null && authStore.user !== undefined
  }

  const updateFeedbackWidget = () => {
    if (isAuthenticated() && !widget) {
      widget = feedback.createWidget()
      widget.appendToDom()
      if (authStore.user?.email) {
        Sentry.setUser({
          username: authStore.user.first_name ?? '',
          email: authStore.user.email ?? ''
        })
      }
    } else if (!isAuthenticated() && widget) {
      widget.removeFromDom()
      widget = null
      Sentry.setUser(null)
    }
  }
  updateFeedbackWidget()
  authStore.$subscribe(updateFeedbackWidget)
}